import React from 'react';
import PropTypes from 'prop-types';
import OverlayController from "../overlay/OverlayController";
import CreateProjectDialog from './CreateProjectDialog';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import Subheader from 'material-ui/Subheader';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import AddIcon from 'material-ui/svg-icons/content/add';
import { withRouter } from 'react-router';
import './ProjectSelector.css';

class ProjectSelector extends React.Component {

    onMenuItemSelect(menuItem) {
        if (menuItem.key === "create_project") {
            OverlayController.showOverlay({
                component: <CreateProjectDialog />,
                className: "createProjectDialogOverlayContent"
            });
        } else {
            this.props.router.push('/projects/' + menuItem.key);
        }
    }

    render() {
        let menuItemStyle = {lineHeight: '32px', minHeight: '32px', fontSize: '15px'};

        return (
            <div className="project-selector">
                <div className="project-selector-project-info">
                    <div className="project-selector-project-label">Project</div>
                    <div className="project-selector-project-name">{this.props.project.name}</div>
                </div>
                <IconMenu
                    listStyle={{paddingTop: '16px', paddingBottom: '16px', width: 200}}
                    onItemTouchTap={(event, menuItem) => this.onMenuItemSelect(menuItem)}
                    className="project-selector-icon-menu"
                    iconButtonElement={
                        <IconButton touch={true} className="project-selector-expand-button">
                            <NavigationExpandMoreIcon className="project-selector-expand-icon" />
                        </IconButton>
                    }
                    anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                    targetOrigin={{horizontal: 'left', vertical: 'top'}}
                >
                    <Subheader style={{fontSize: 13, lineHeight: '28px', paddingLeft: 24}}>Projects</Subheader>
                    {this.props.projectList.map(project =>
                        <MenuItem key={project.id} primaryText={project.name} style={menuItemStyle} innerDivStyle={{padding: '0 24px'}} />
                    )}
                    <Divider />
                    <MenuItem
                        key="create_project"
                        primaryText="Create Project"
                        style={Object.assign({color: '#757575'}, menuItemStyle)}
                        innerDivStyle={{paddingLeft: 44}}
                        leftIcon={<AddIcon style={{height: 20, width: 20, margin: 0, left: 16, top: 6, fillColor: '#757575'}}/>} />
                </IconMenu>
            </div>
        );
    }

}

ProjectSelector.propTypes = {
    project: PropTypes.object.isRequired,
    projectList: PropTypes.array
};
ProjectSelector.defaultProps = {
    projectList: []
};

export default withRouter(ProjectSelector);



// WEBPACK FOOTER //
// ./src/components/sidebar/ProjectSelector.js